export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN = 'refreshToken';
export const PERFIL_ACTIVO_KEY = 'multiperfil:perfilActivo';
// Responsive up size
export const mediaBreackpointUpXs = 320;
export const mediaBreackpointUpSm = 576;
export const mediaBreackpointUpMd = 768;
export const mediaBreackpointUpLg = 992;
export const mediaBreackpointUpXl = 1200;
